var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Title, Tooltip } from '@gerdau/hefesto';
import './KeyValueItem.styles.scss';
var KeyValueItem = function (_a) {
    var children = _a.children, helperText = _a.helperText, helperTextTooltipPlacement = _a.helperTextTooltipPlacement, title = _a.title, _b = _a.titleLevel, titleLevel = _b === void 0 ? 5 : _b;
    var hasInfo = !!helperText;
    return (_jsxs("div", __assign({ className: "hefesto-keyvalueitem" }, { children: [_jsxs("div", __assign({ className: "hefesto-keyvalueitem__label-wrapper" }, { children: [_jsx("div", __assign({ className: "hefesto-keyvalueitem__label" }, { children: _jsx(Title, __assign({ level: titleLevel }, { children: title })) })), !!hasInfo && (_jsx(Tooltip, __assign({ title: helperText, placement: helperTextTooltipPlacement }, { children: _jsx("i", __assign({ className: "hefesto-keyvalueitem__info-icon" }, { children: _jsx(Icon, { option: "Info", variant: "info" }) })) })))] })), _jsx("div", __assign({ className: "hefesto-keyvalueitem__value" }, { children: children }))] })));
};
export default KeyValueItem;
